import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { People, CheckCircle, Warning, Block, PersonAdd } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface UserStatsCardsProps {
  userStats: {
    totalUsers: number;
    activeUsers: number;
    suspendedUsers: number;
    deactivatedUsers: number;
    newUsersThisMonth: number;
  } | null;
}

const UserStatsCards: React.FC<UserStatsCardsProps> = ({ userStats }) => {
  const { t } = useTranslation();

  if (!userStats) return null;

  const stats = [
    {
      label: t('admin.totalUsers'),
      value: userStats.totalUsers,
      icon: <People sx={{ color: '#00d4ff', mr: 1 }} />,
    },
    {
      label: t('warranty.active'),
      value: userStats.activeUsers,
      icon: <CheckCircle sx={{ color: '#00ff88', mr: 1 }} />,
    },
    {
      label: t('warranty.pending'),
      value: userStats.suspendedUsers,
      icon: <Warning sx={{ color: '#ffaa00', mr: 1 }} />,
    },
    {
      label: t('admin.deactivated'),
      value: userStats.deactivatedUsers,
      icon: <Block sx={{ color: '#ff0080', mr: 1 }} />,
    },
    {
      label: t('admin.newThisMonth'),
      value: userStats.newUsersThisMonth,
      icon: <PersonAdd sx={{ color: '#00d4ff', mr: 1 }} />,
    },
  ];

  return (
    <Box sx={{ display: 'flex', gap: 3, mb: 4, flexWrap: 'wrap' }}>
      {stats.map((stat, index) => (
        <Card
          key={index}
          sx={{
            flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)', lg: '1 1 calc(20% - 24px)' },
            bgcolor: 'background.paper',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              {stat.icon}
              <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                {stat.label}
              </Typography>
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
              }}
            >
              {stat.value}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default UserStatsCards;